import { apiPost, apiDelete } from "@/lib/api/client";

/**
 * Thin wrappers over the places enrichment / publish endpoints.
 *
 * These isolate the raw `apiPost` / `apiDelete` calls that the enrichment state
 * machine (usePlaceEnrichment) makes, so the hook reads as control flow rather
 * than URL string-building. Behavior is byte-identical to the inline calls that
 * previously lived in PlaceListModule:
 *   - enrich:    POST /places/:id/enrich   {}
 *   - publish:   POST /places/:id/publish  {}
 *   - unpublish: DELETE /places/:id/publish
 */

export async function enrichPlace(placeId: string): Promise<any> {
  const { data } = await apiPost<any>(`/places/${placeId}/enrich`, {});
  return data;
}

export async function publishPlace(
  placeId: string,
): Promise<{ slug: string; url: string }> {
  const { data } = await apiPost<{ slug: string; url: string }>(
    `/places/${placeId}/publish`,
    {},
  );
  return data;
}

export async function unpublishPlace(placeId: string): Promise<void> {
  await apiDelete(`/places/${placeId}/publish`);
}
